import React, { useEffect, useRef, useState, Component } from 'react';
import PropTypes from 'prop-types';
import DebugLogger from "../../../helpers/DebugLogger";
import axios from "../../../api/axios";

import { assets } from "../../../assets/assets";

import FontPicker from "font-picker-react";
// import DefaultPlaceholderImg from "./placeholder.png";
import "./FontSelector.scss";
import { IconJsxer } from '../../../helpers/IconHelper';


/*
Applying the selected font
Add the class "apply-font" to all JSX elements you want to apply the selected font to.

When the user selects a font, it will automatically be downloaded and applied to all elements with the "apply-font" class.

https://github.com/samuelmeuli/font-picker-react

*/
export default class FontSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeFontFamily: "Open Sans",
		};
	}

	render() {
		return (
			<div>
				<FontPicker
					apiKey="AIzaSyCK-FT-TdFUvWTWBQ_hxsoU_HS6GHeytWg"
					activeFontFamily={this.state.activeFontFamily}
					limit={250}
					onChange={(nextFont) =>
						{
							console.log(nextFont.family)
							this.setState({
								activeFontFamily: nextFont.family,
							})
						}
					}
				/>
				<p className="apply-font">The font will be applied to this text.</p>
			</div>
		);
	}
}

//export default FontSelector; 
